import { components } from "react-select";
import { payrollItemStatusMap } from "features/Payroll/constants/payroll.constants";
import type { PayrollItemSelectOption } from "features/Payroll/types/payroll.types";
import { formatCurrency } from "utils/currency";

function StatusBadge({ status }: { status: string | undefined }) {
  if (!status) return null;
  const entry = payrollItemStatusMap[status];
  if (!entry) return null;
  return (
    <span className={`badge bg-${entry.color}-subtle text-${entry.color} ms-1`}>
      {entry.label}
    </span>
  );
}

export function PayrollItemOption(props: any) {
  const data = props.data as PayrollItemSelectOption;

  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="fw-medium text-body">{data.label}</span>
          <StatusBadge status={data.status} />
        </div>
        <div className="d-flex justify-content-between mt-1">
          <small className="text-muted">
            {data.payrollRunCode ? `Run ${data.payrollRunCode}` : ""}
          </small>
          {data.netAmount != null ? (
            <small className="text-muted">
              Net: <span className="text-body">{formatCurrency(data.netAmount)}</span>
            </small>
          ) : null}
        </div>
      </div>
    </components.Option>
  );
}

export function PayrollItemSingleValue(props: any) {
  const data = props.data as PayrollItemSelectOption;

  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex align-items-center gap-1 min-w-0 text-truncate">
        <span className="text-truncate">{data.label}</span>
        {data.payrollRunCode ? (
          <span className="text-muted text-truncate small">
            · Run {data.payrollRunCode}
          </span>
        ) : null}
      </span>
    </components.SingleValue>
  );
}
